<template>
  <nav class="flex-between-center">
    <ul class="pagination pagination-sm">
      <li class="page-item" v-bind:class="{'disabled': disablePrev}">
        <a class="page-link" href="#" tabindex="-1" @click.prevent="prevPage()">{{this.$t('messeges.previous')}}</a>
      </li>
      <li v-for="n in range" :key="n" v-if="showLink(offsetPage(n))" class="page-item" v-bind:class="{'active': isActive(offsetPage(n))}">
        <a class="page-link" href="#" @click.prevent="getPage(offsetPage(n))">{{ offsetPage(n) }}</a>
      </li>
      <li class="page-item" v-bind:class="{'disabled': disableNext}">
        <a class="page-link" href="#" @click.prevent="nextPage()">{{this.$t('messeges.next')}}</a>
      </li>
    </ul>
    <div class="pagination-input-container flex-between-center pagination">
      <p class="reset-margin">{{this.$t('messeges.part1')}}{{ currentPage }}{{this.$t('messeges.part2')}}{{ totalPages }} <span v-if="recordCountDefined">{{$t('messeges.recordsPart1')}} {{ recordCount }}{{$t('messeges.part2')}}{{ totalRecords }}{{$t('messeges.recordsPart2')}}</span> {{this.$t('messeges.part3')}}</p>
      <input class="pagination-input space-left" v-model.number="goToPage" @keyup.enter.prevent="getSpecificPage">
    </div>
  </nav>
</template>

<script>
import messages from './Pagination.messages'
export default {
  name: 'Pagination',
  props: {
    range: {
      type: Number,
      default: 5
    },
    totalPages: {
      type: Number,
      default: 25
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalRecords: {
      type: Number,
      required: false
    },
    pageSize: {
      type: Number,
      required: false
    },
    recordCount: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      goToPage: this.currentPage
    }
  },
  computed: {
    recordCountDefined () {
      return this.totalRecords !== undefined
    },
    disablePrev () {
      return this.page <= this.minSize
    },
    disableNext () {
      return this.page >= this.ps - this.minSize
    },
    ps () {
      return this.totalPages + 1
    },
    page: {
      get () {
        return this.currentPage
      },
      set (cp) {
        // this.$shipBobStore.dispatch('orders/setCurrentPage', cp)
        this.fetchPage(cp)
      }
    }
  },
  methods: {
    showLink (pageNum) {
      return pageNum > 0 && pageNum < this.totalPages + 1
    },
    offsetPage (n) {
      const mid = Math.ceil(this.range / 2)
      if (n < mid) return this.page - (mid - n)
      return this.page + (n % mid)
    },
    isActive (n) {
      return n === this.page
    },
    nextPage () {
      let newPageNumber = (this.page + 1) % this.ps
      if (newPageNumber === 0) newPageNumber = 1
      // this.page = ++this.page % this.ps
      // if (this.page === 0) this.page = 1
      this.page = newPageNumber
      // this.fetchPage()
    },
    prevPage () {
      let newPageNumber = (this.page - 1 + this.ps) % this.ps
      if (newPageNumber === 0) newPageNumber = this.totalPages
      // this.page = (--this.page + this.ps) % this.ps
      // if (this.page === 0) this.page = this.totalPages
      this.page = newPageNumber
      // this.fetchPage()
    },
    getSpecificPage (e) {
      e.target.blur()
      if (isNaN(parseInt(this.goToPage))) return
      this.getPage(Math.max(Math.min(this.goToPage, this.totalPages), 1))
    },
    getPage (n) {
      this.page = n
      // this.fetchPage()
    },
    fetchPage (pageNumber) {
      this.$emit('fetchPage', {page: pageNumber, totalPages: this.totalPages})
    }
  },
  i18n: {messages}
}
</script>
<style scoped>
.flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reset-margin {
  margin: 0;
}
.pagination-input-container {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #9ea1a7;
}
.pagination-input {
  padding: 0.5rem 0.25rem;
  width: 2.5em;
  height: 37px;
  border-radius: 2px;
  background-color: #ffffff;
  border: solid 0.5px #ced0d3;
  color: #9ea1a7;
}
.space-left {
  margin-left: 1em;
}
</style>